import React, { Suspense, useEffect, useState } from 'react';
import Header from '../Header/header';
import { CommonUtilities } from '../../commonUtils';
import korrectLogo from '../../assets/images/korrectLogoIcon.png';



export default function Contracts(autoOpen: any) {

    return (
        <div className='ws-12'>
            <div className="plxl prxl">
                <div className="ptxl mtl ptl">
                    <div className="ws-9">
                        <span className="ws-12 text-bold text-xl">Contracts</span>
                        <span className="ws-12 ptl text-bold text-m turquoise">Contract Header</span>
                    </div>
                </div>
                <div className="ws-12 ptxl">
                    <div className="ws-12">

                        <fieldset className="scheduler-border p0 m0">
                            <legend className="scheduler-border">
                                <h2>
                                    <i className="fa fa-sticky-note-o"></i> Contract Info
                                </h2>
                            </legend>
                            <form className="form-horizontal form-condensed  row-fluid ng-pristine ng-valid" name="songform">
                                <div className="ws-12">

                                    <div className="ws-4">
                                        <div className="form-format">
                                            <label className="control-label ws-4 text-right pr">
                                                Contract Code :
                                            </label>
                                            <div className="label-entries ws-8">
                                                ARTISTSERVE001
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-4">
                                        <div className="form-format">
                                            <label className="control-label ws-4 text-right pr">
                                                Contract Title :
                                            </label>
                                            <div className="label-entries ws-8">
                                                Culture Code Agreement
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-4">
                                        <div className="form-format">
                                            <label className="control-label ws-4 text-right pr">
                                                Contact :
                                            </label>
                                            <div className="label-entries ws-8">
                                                artistserve.com (ARSE056594)
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </fieldset>

                    </div>
                </div>
            </div>

            <div className="plxl prxl mtl">
                <div className="ptxl mtl ptl">
                    <div className="ws-9">
                        <span className="ws-12 ptl text-bold text-m turquoise">Contract Header</span>
                    </div>
                </div>
                <div className="ws-12 ptxl">
                    <div className="ws-12">

                        <div className="w-14-2 pm">
                            <div className="topFrame topFrame_paleBlue ws-12 pull-left mb">
                                <label className="ws-12 text-left mts text-bold" style={{ height : '34px' }}>Prior Balance</label>
                                <div className="label-entries ws-12 text-m text-bold mt mb text-right">
                                    <span className="ws-12" ng-click="openIndicator(contractIndicators, 'period_balance', contractIndicators.totalValue === 0, false)">
                                        0.00</span>
                                </div>
                            </div>
                            <div className="ws-12 hide">
                                <div className="ws-12 mt text-center">Gross</div>
                                    <div className="ws-12 mbl" ng-repeat="(index, item) in contractTotalBal">
                                    <span className="pull-right">128.70</span>
                                </div>
                            </div>
                        </div>

                        <div className="w-14-2 pm">
                            <div className="topFrame topFrame_darkBlue  ws-12 pull-left mb">
                                <label className="ws-12 text-left mts text-bold" style={{ height : '34px' }}>Last Payment</label>
                                <div className="label-entries ws-12 text-m text-bold mt mb text-right">
                                    <span className="ws-12" ng-click="openIndicator(contractIndicators, 'period_balance', contractIndicators.totalValue === 0, false)">
                                        0.00</span>
                                </div>
                            </div>
                            <div className="ws-12 hide">
                                <div className="ws-12 mt text-center">Gross</div>
                                    <div className="ws-12 mbl" ng-repeat="(index, item) in contractTotalBal">
                                    <span className="pull-right">128.70</span>
                                </div>
                            </div>
                        </div>

                        <div className="w-14-2 pm">
                            <div className="topFrame topFrame_turquoise  ws-12 pull-left mb">
                                <label className="ws-12 text-left mts text-bold" style={{ height : '34px' }}>Opening Balance</label>
                                <div className="label-entries ws-12 text-m text-bold mt mb text-right">
                                    <span className="ws-12" ng-click="openIndicator(contractIndicators, 'period_balance', contractIndicators.totalValue === 0, false)">
                                        0.00</span>
                                </div>
                            </div>
                            <div className="ws-12 hide">
                                <div className="ws-12 mt text-center">Gross</div>
                                    <div className="ws-12 mbl" ng-repeat="(index, item) in contractTotalBal">
                                    <span className="pull-right">128.70</span>
                                </div>
                            </div>
                        </div>

                        <div className="w-14-2 pm">
                            <div className="topFrame topFrame_purple  ws-12 pull-left mb">
                                <label className="ws-12 text-left mts text-bold" style={{ height : '34px' }}>Earnings</label>
                                <div className="label-entries ws-12 text-m text-bold mt mb text-right">
                                    <span className="ws-12" ng-click="openIndicator(contractIndicators, 'period_balance', contractIndicators.totalValue === 0, false)">
                                        0.00</span>
                                </div>
                            </div>
                            <div className="ws-12 hide">
                                <div className="ws-12 mt text-center">Gross</div>
                                    <div className="ws-12 mbl" ng-repeat="(index, item) in contractTotalBal">
                                    <span className="pull-right">128.70</span>
                                </div>
                            </div>
                        </div>

                        <div className="w-14-2 pm">
                            <div className="topFrame topFrame_orange  ws-12 pull-left mb">
                                <label className="ws-12 text-left mts text-bold" style={{ height : '34px' }}>Recoupables</label>
                                <div className="label-entries ws-12 text-m text-bold mt mb text-right">
                                    <span className="ws-12" ng-click="openIndicator(contractIndicators, 'period_balance', contractIndicators.totalValue === 0, false)">
                                        0.00</span>
                                </div>
                            </div>
                            <div className="ws-12 hide">
                                <div className="ws-12 mt text-center">Gross</div>
                                    <div className="ws-12 mbl" ng-repeat="(index, item) in contractTotalBal">
                                    <span className="pull-right">128.70</span>
                                </div>
                            </div>
                        </div>

                        <div className="w-14-2 pm">
                            <div className="topFrame topFrame_orange  ws-12 pull-left mb">
                                <label className="ws-12 text-left mts text-bold" style={{ height : '34px' }}>Adjustments</label>
                                <div className="label-entries ws-12 text-m text-bold mt mb text-right">
                                    <span className="ws-12" ng-click="openIndicator(contractIndicators, 'period_balance', contractIndicators.totalValue === 0, false)">
                                        0.00</span>
                                </div>
                            </div>
                            <div className="ws-12 hide">
                                <div className="ws-12 mt text-center">Gross</div>
                                    <div className="ws-12 mbl" ng-repeat="(index, item) in contractTotalBal">
                                    <span className="pull-right">128.70</span>
                                </div>
                            </div>
                        </div>

                        <div className="w-14-2 pm">
                            <div className="topFrame topFrame_paleBlue ws-12 pull-left mb">
                                <label className="ws-12 text-left mts text-bold" style={{ height : '34px' }}>Total Balance</label>
                                <div className="label-entries ws-12 text-m text-bold mt mb text-right">
                                    <span className="ws-12" ng-click="openIndicator(contractIndicators, 'period_balance', contractIndicators.totalValue === 0, false)">
                                        0.00</span>
                                </div>
                            </div>
                            <div className="ws-12 hide">
                                <div className="ws-12 mt text-center">Gross</div>
                                    <div className="ws-12 mbl" ng-repeat="(index, item) in contractTotalBal">
                                    <span className="pull-right">128.70</span>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>


        </div>
    )
}